document.addEventListener('DOMContentLoaded', function () {
  var stickyButton = document.querySelector('[data-rc-sticky-atc-button]');
  if (!stickyButton) return;
  stickyButton.addEventListener('click', function () {
    var productSubmit = document.querySelector('[id^="ProductSubmitButton-"]');
    if (productSubmit && !productSubmit.disabled) productSubmit.click();
  });
});

(function () {
  function initSizeGuideZoom() {
    var modal = document.querySelector('[data-rc-size-guide-modal]');
    var modalImage = document.querySelector('[data-rc-size-guide-modal-image]');
    var closeButton = document.querySelector('[data-rc-size-guide-close]');
    var triggers = document.querySelectorAll('[data-rc-size-guide-zoom]');
    if (!modal || !modalImage || !closeButton || !triggers.length) return;

    function openModal(img) {
      modalImage.src = img.currentSrc || img.src;
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rc-modal-open');
      closeButton.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', 'hidden');
      modal.setAttribute('aria-hidden', 'true');
      modalImage.src = '';
      document.documentElement.classList.remove('rc-modal-open');
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var img = trigger.querySelector('img');
        if (img) openModal(img);
      });
    });

    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideZoom);
  } else {
    initSizeGuideZoom();
  }
})();
